 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import HALFTITLE from '@/components/Halftitle'
 import TITLE from '@/components/Title'
 import COPYRIGHT from '@/components/Copyright'
 import DEDICATION from '@/components/Dedication'
 import FORWORD from '@/components/Forword'
 import PREFACE from '@/components/Preface'
 import ACKNOWLEDGEMENTS from '@/components/Acknowledgements'
 import INTRODUCTION from '@/components/Introduction'
 import PART_1 from '@/components/Part_1'
 import CHAP1 from '@/components/Chap1'
 import PART_2 from '@/components/Part_2'
 import CHAP2 from '@/components/Chap2'
 import CHAP3 from '@/components/Chap3'
 import CHAP4 from '@/components/Chap4'
 import CHAP5 from '@/components/Chap5'
 import CHAP6 from '@/components/Chap6'
 import PART_3 from '@/components/Part_3'
 import CHAP7 from '@/components/Chap7'
 import CHAP8 from '@/components/Chap8'
 import CHAP9 from '@/components/Chap9'
 import CHAP10 from '@/components/Chap10'
 import RESOURCES from '@/components/Resources'
 import BIBLIOGRAPHY from '@/components/Bibliography'
 import ADDITIONALMODELS from '@/components/AdditionalModels'
 import ABOUTINTERACTION from '@/components/AboutInteraction'
 import INSTITUTEFORSOCIAL from '@/components/InstituteforSocial'
 import INDEX from '@/components/Index'
 import ABOUTTHEAUTHOR from '@/components/AbouttheAuthor'
 import BERRETTKOEHLER from '@/components/BerrettKoehler'
 import CHAP4_T1 from '@/components/Chap4_T1'
 import CHAP4_T2 from '@/components/Chap4_T2'
 import CHAP4_T3 from '@/components/Chap4_T3'
 import ADDITIONALMODELS_T1 from '@/components/AdditionalModels_T1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Cover",
 			"name" : "Cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/Halftitle",
 			"name" : "Halftitle",
 			"component" : HALFTITLE
 		},
 		{
 			"path" : "/Title",
 			"name" : "Title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/Copyright",
 			"name" : "Copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/Dedication",
 			"name" : "Dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/Forword",
 			"name" : "Forword",
 			"component" : FORWORD
 		},
 		{
 			"path" : "/Preface",
 			"name" : "Preface",
 			"component" : PREFACE
 		},
 		{
 			"path" : "/Acknowledgements",
 			"name" : "Acknowledgements",
 			"component" : ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/Introduction",
 			"name" : "Introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/Part_1",
 			"name" : "Part_1",
 			"component" : PART_1
 		},
 		{
 			"path" : "/Chap1",
 			"name" : "Chap1",
 			"component" : CHAP1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js